import {AdxAlertRule, PriceAlertRule, TradingAlertRule} from "../../../models/rules/TradingAlertRule";
import {AppUtil} from "../../../../js/util/AppUtil";
import {TradingAlertRuleType} from "../../../models/rules/TradingAlertRuleType";
import {ObjectUtil} from "../../../../js/util/ObjectUtil";
import {isDialogPriceRule} from "./AlertDialogPriceRule";
import {isDialogAdxRule} from "./AlertDialogAdxRule";
import {PriceAlertType} from "../rules/price/models/PriceAlertType";
import {AdxAlertType} from "../rules/adx/models/AdxAlertType";

export interface AlertDialogRule extends TradingAlertRule {
    readonly uiid: string;
}

export function addUiId(rule: TradingAlertRule): AlertDialogRule {
    const copy: any = ObjectUtil.copy(rule);
    copy.uiid = AppUtil.uuid();
    return copy;
}

export function defaultRule(): AlertDialogRule {
    const id = AppUtil.uuid();
    return {
        uiid: id,
        type: TradingAlertRuleType.PRICE
    };
}

export function stripExcessValues(rule: AlertDialogRule): TradingAlertRule {
    if (isDialogPriceRule(rule)) {
        if (rule.priceType == null) {
            return ObjectUtil.pick(rule, "type", "priceAbove", "priceBelow", "pricePercentMove");
        }
        const result: PriceAlertRule = {
            type: TradingAlertRuleType.PRICE,
            priceAbove: rule.priceType === PriceAlertType.ABOVE ? rule.priceAbove : null,
            priceBelow: rule.priceType === PriceAlertType.BELOW ? rule.priceBelow : null,
            pricePercentMove: rule.priceType === PriceAlertType.MOVE ? rule.pricePercentMove : null
        };
        return result;
    } else if (isDialogAdxRule(rule)) {
        if (rule.adxType == null) {
            return ObjectUtil.pick(rule, "type", "adxAbove", "adxBelow");
        }
        const result: AdxAlertRule = {
            type: TradingAlertRuleType.ADX,
            adxAbove: rule.adxType === AdxAlertType.ABOVE ? rule.adxAbove : null,
            adxBelow: rule.adxType === AdxAlertType.BELOW ? rule.adxBelow : null
        };
        return result;
    } else {
        throw Error("Unhandled Rule " + JSON.stringify(rule));
    }
}
